import React, { useEffect, useRef, useState } from "react";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import { useGlobalState } from "../Context/GlobalStateContext";
import moment from "moment";
import {
  addMinutes,
  GetDurationTextForSeconds,
  NumbersInWords,
} from "../Shared/Utility";
import ConfirmationModal from "./ConfirmationModal";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import {
  showErrorMessage,
  showInfoMessage,
  showSuccessMessage,
} from "../Shared/Toast";
import Conversation from "./Conversation";

// Props interface
interface Props {
  QuoteID: any;
  RelMNVQuoteAndMNVMoverID?: any;
  ClosePopupAndAutoSendSms?: any;
}

const CompleteJob = (props: Props) => {
  const globalState = useGlobalState();
  /* ===================== STATE ===================== */
  const [MNVQuote, setMNVQuote] = useState<any>({});
  const MNVQuoteRef = useRef<any | null>(null);
  MNVQuoteRef.current = MNVQuote;
  const [QuoteCalculations, setQuoteCalculations] = useState<any>({
    AmountBeforeVAT: 0,
    TotalVAT: 0,
    Balance: 0,
  });
  const [LineItems, setLineItems] = useState<any>([]);
  const [LineItemsAmounts, setLineItemsAmounts] = useState<any>({});
  const [QuoteRelatedPaymentAccount, setQuoteRelatedPaymentAccount] =
    useState<any>([]);
  const [ClientData, setClientData] = useState<any>({});
  const [PaymentObject, setPaymentObject] = useState<any>({});
  const [Error, setError] = useState<any>({});

  const [SendReviewEmail, setSendReviewEmail] = useState(false);
  const [BusinessCard, setBusinessCard] = useState(false);
  const [MagneticCard, setMagneticCard] = useState(false);
  const [SocialMediaLeaflet, setSocialMediaLeaflet] = useState(false);

  const [IsThisLastVanToComplete, setIsThisLastVanToComplete] = useState(false);

  const [AdditionalServices, setAdditionalServices] = useState<any>([]);
  const [VanText, setVanText] = useState("");
  const [JobRelatedData, setJobRelatedData] = useState({});
  const [LineMainItems, setLineMainItems] = useState([]);
  const [showAnimation, setShowAnimation] = useState(false);

  const [showAddCostModal, setShowAddCostModal] = useState(false);
  const [showSendPaymentLink, setShowSendPaymentLink] = useState(false);
  const [showAddPaymentMethods, setShowAddPaymentMethods] = useState(false);
  /* ===================== INIT ===================== */

  const [AutoSaveMessage, setAutoSaveMessage] = useState(false);
  const [markAsComplete, setMarkAsComplete] = useState(false);

  useEffect(() => {
    setAutoSaveMessage(false);
    GetQuoteInfoById(true);
    GetQuoteRelatedPaymentAccountDetails(props.QuoteID);
  }, []);

  useEffect(() => {
    CalculateAdditionalTimeAmount();
  }, [
    MNVQuote.AdditionalTimeInHours,
    MNVQuote.AdditionalTimeInMinutes,
    QuoteCalculations.AdditionalRateAndVAT,
  ]);

  useEffect(() => {
    CalculateAdditionalStairsAmount();
  }, [MNVQuote.Mover3ID]);

  /* ===================== API FUNCTIONS ===================== */

  const GetQuoteInfoById = (loadCharges: any) => {
    // Default.SetMasterAnimationV2(true);
    let data: any = {};
    data.MNVQuoteID = Number(props.QuoteID);
    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuoteAdmin/MNVQuoteGetQuoteByID", data)
      .then((res) => {
        const quote: any = res.data.Data[0][0];
        MNVQuoteRef.current = res.data.Data[0][0];
        setMNVQuote(res.data.Data[0][0]);

        if (res.data.Data[0][4]?.length) {
          setVanText(" - Van 1");
          setAdditionalServices(res.data.Data[4]);
        } else if (res.data.Data[5]?.length) {
          setAdditionalServices(res.data.Data[5]);
          res.data.Data[5].forEach((x: any, i: any) => {
            if (x.MNVQuoteID === props.QuoteID) setVanText(` - Van ${i + 2}`);
          });
        }

        GetInvoiceDataByQuoteID();
        CheckIfAllTheOtherVansAreCompleted(0);

        if (loadCharges) GetAdditionalCharges();
        else {
          CalculateAdditionalTimeAmount();
        }

        setClientData({
          EmailAddress: quote.EmailAddress,
          Mobile: quote.Mobile,
        });
      });
  };

  const GetInvoiceDataByQuoteID = () => {
    let data = {} as any;
    data.MNVQuoteID = GetMainJobID();
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/GetInvoiceDataByQuoteID",
        data,
      )
      .then((res) => {
        const invoice = res.data[0] as any[];
        const responseLineItems = res.data[1] as any[];
        const lineMainItems = res.data[2] as any;

        let list: any[] = [];
        let taxFreeCredit = 0;

        // reset amounts
        setLineItemsAmounts((prev: any) => ({
          ...prev,
          Balance: 0,
          Credit: 0,
          Debit: 0,
          Refund: 0,
          Cancellation: 0,
          OverallCancellation: 0,
          OverAllCredit: 0,
          OverAllDebit: 0,
          OverAllRefund: 0,
          OverAllSubtotal: 0,
          OverAllVAT: 0,
          OverAllTotal: 0,
          OverAllPaid: 0,
          OverAllBalance: 0,
          OverAllOtherDiscount: 0,
        }));

        for (let i = 0; i < responseLineItems.length; i++) {
          if (
            responseLineItems[i].SourceType === 2 ||
            responseLineItems[i].SourceType === 3
          ) {
            if (responseLineItems[i].OtherObjectID === props.QuoteID) {
              if (
                responseLineItems[i].AddedByLoggedInUser === 1 ||
                (responseLineItems[i].RefferenceNumber.includes("Additional") &&
                  (responseLineItems[i].RefferenceNumber.includes("hour") ||
                    responseLineItems[i].RefferenceNumber.includes("minute") ||
                    responseLineItems[i].RefferenceNumber.includes("Stair") ||
                    responseLineItems[i].RefferenceNumber.includes("Stairs") ||
                    responseLineItems[i].RefferenceNumber.includes("Time")))
              ) {
                list.push(responseLineItems[i]);

                if (
                  responseLineItems[i].AddedByLoggedInUser === 1 ||
                  responseLineItems[i].RefferenceNumber.includes(VanText)
                ) {
                  list[list.length - 1].CanDelete = true;
                }

                if (responseLineItems[i].ObjectType === 7) {
                  taxFreeCredit += responseLineItems[i].Amount;
                }
              }
            } else {
              for (let as = 0; as < AdditionalServices.length; as++) {
                if (
                  responseLineItems[i].OtherObjectID ===
                    AdditionalServices[as].MNVQuoteID ||
                  responseLineItems[i].OtherObjectID ===
                    AdditionalServices[as].ParentID
                ) {
                  if (
                    responseLineItems[i].AddedByLoggedInUser === 1 ||
                    (responseLineItems[i].RefferenceNumber.includes(
                      "Additional",
                    ) &&
                      (responseLineItems[i].RefferenceNumber.includes("hour") ||
                        responseLineItems[i].RefferenceNumber.includes(
                          "minute",
                        ) ||
                        responseLineItems[i].RefferenceNumber.includes(
                          "Stair",
                        ) ||
                        responseLineItems[i].RefferenceNumber.includes(
                          "Stairs",
                        ) ||
                        responseLineItems[i].RefferenceNumber.includes("Time")))
                  ) {
                    list.push(responseLineItems[i]);

                    if (
                      responseLineItems[i].AddedByLoggedInUser === 1 ||
                      responseLineItems[i].RefferenceNumber.includes(VanText)
                    ) {
                      list[list.length - 1].CanDelete = true;
                    }

                    if (responseLineItems[i].ObjectType === 7) {
                      taxFreeCredit += responseLineItems[i].Amount;
                    }
                  }
                }
              }
            }
          }
        }

        // ---- INVOICE TOTALS ----
        if (invoice?.length > 0) {
          const balance = invoice[0].Balance;

          setLineItemsAmounts((prev: any) => ({
            ...prev,
            Balance: balance,
          }));

          let amountBeforeVAT = 0;
          if (balance != 0) {amountBeforeVAT=(balance - taxFreeCredit) / 1.2 + taxFreeCredit};

          setQuoteCalculations((prev: any) => ({
            ...prev,
            AmountBeforeVAT: amountBeforeVAT,
            TotalVAT: balance - amountBeforeVAT,
          }));
        }
        // ---- INVOICE TOTALS ----
        // if (invoice?.length > 0) {
        //   const balance = invoice[0].Balance;

        //   setLineItemsAmounts((prev: any) => ({
        //     ...prev,
        //     Balance: balance,
        //   }));

        //   let amountBeforeVAT = 0;
        //   if (balance != 0) {
        //     // Fix: Assign the calculated value to amountBeforeVAT
        //     amountBeforeVAT = (balance - taxFreeCredit) / 1.2 + taxFreeCredit;
        //   }

        //   setQuoteCalculations((prev: any) => ({
        //     ...prev,
        //     AmountBeforeVAT: amountBeforeVAT,
        //     TotalVAT: balance - amountBeforeVAT,
        //   }));
        // }

        // ---- FINAL SET ----
        setLineItems(list);
        setLineMainItems(lineMainItems);
      });
  };

  const GetQuoteRelatedPaymentAccountDetails = (id: any) => {
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteAdmin/GetQuoteRelatedPaymentAccountDetails",
        { QuoteID: id },
      )
      .then((res) => {
        setQuoteRelatedPaymentAccount(res.data[0]);
      });
  };

  const GetAdditionalCharges = () => {
    const data = { MNVQuoteID: props.QuoteID };
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVRates/MNVRatesGetDataSetForAdditionalCharges",
        {
          data,
        },
      )
      .then((res) => {
        const Rates = res.data.Data[0];
        const Tier = "Tier" + MNVQuoteRef.current.TierID + "Add";
        const VanRate = Rates.find(
          (x: any) =>
            x.ObjectTypeID === 1 &&
            x.ObjectID === MNVQuoteRef.current.MNVVanTypeID,
        );
        const HelperRate = Rates.find((x: any) => x.ObjectTypeID === 2);

        const addRate =
          VanRate[Tier] +
          (MNVQuoteRef.current.MNVMoverTypeID > 1 ? (HelperRate[Tier] * (MNVQuoteRef.current.MNVMoverTypeID-1)): 0);
        setQuoteCalculations((q: any) => ({
          ...q,
          AdditionalRateAndVAT: addRate,
          DriverPerStairRate: VanRate.PerStairRate,
          HelperPerStairRate: HelperRate.PerStairRate,
        }));

        CalculateAdditionalTimeAmount(1);
      });
  };

  const CalculateAdditionalTimeAmount = (needToChange = 0) => {
    let updatedQuote = { ...MNVQuoteRef.current };

    if (needToChange) {
      if (updatedQuote.AdditionalTimeInHours === undefined) {
        if (updatedQuote.Mover2ID / 60 >= 1) {
          updatedQuote.AdditionalTimeInHours = Math.floor(
            updatedQuote.Mover2ID / 60,
          );
        } else {
          updatedQuote.AdditionalTimeInHours = 0;
        }
      }

      if (updatedQuote.AdditionalTimeInMinutes === undefined) {
        if (updatedQuote.Mover2ID % 60 >= 1) {
          updatedQuote.AdditionalTimeInMinutes = Math.floor(
            updatedQuote.Mover2ID % 60,
          );
        } else {
          updatedQuote.AdditionalTimeInMinutes = 0;
        }
      }
    }

    let totalTimeInMinutes = 0;

    if (
      updatedQuote.AdditionalTimeInHours !== undefined &&
      updatedQuote.AdditionalTimeInHours !== ""
    ) {
      totalTimeInMinutes += updatedQuote.AdditionalTimeInHours * 60; // integer math
    }

    if (
      updatedQuote.AdditionalTimeInMinutes !== undefined &&
      updatedQuote.AdditionalTimeInMinutes !== ""
    ) {
      totalTimeInMinutes += parseFloat(updatedQuote.AdditionalTimeInMinutes); // integer math
    }

    updatedQuote.Mover2ID = totalTimeInMinutes;
    updatedQuote.AdditionalTimeCharges =
      (totalTimeInMinutes / 30) * QuoteCalculations.AdditionalRateAndVAT;

    MNVQuoteRef.current = updatedQuote;
    setMNVQuote(updatedQuote);

    CalculateAdditionalStairsAmount();
  };

  const CalculateAdditionalStairsAmount = () => {
    const updatedQuote = { ...MNVQuoteRef.current };

    updatedQuote.DriverAdditionalStairsCharges =
      updatedQuote.Mover3ID * QuoteCalculations.DriverPerStairRate;
    updatedQuote.HelperAdditionalStairsCharges =
      updatedQuote.Mover3ID * QuoteCalculations.HelperPerStairRate;

    if (updatedQuote.MNVMoverTypeID === 1) {
      updatedQuote.AdditionalStairsCharges =
        updatedQuote.DriverAdditionalStairsCharges;
    } else if (updatedQuote.MNVMoverTypeID === 2) {
      updatedQuote.AdditionalStairsCharges =
        updatedQuote.DriverAdditionalStairsCharges +
        updatedQuote.HelperAdditionalStairsCharges;
    } else if (updatedQuote.MNVMoverTypeID >= 3) {
      updatedQuote.AdditionalStairsCharges =
        updatedQuote.DriverAdditionalStairsCharges +
        (updatedQuote.MNVMoverTypeID - 1) *
          updatedQuote.HelperAdditionalStairsCharges;
    }
    MNVQuoteRef.current = updatedQuote;
    setMNVQuote(updatedQuote);
  };

  const SaveCharges = () => {
    var l_decCharges = MNVQuote.AdditionalTimeCharges
      ? MNVQuote.AdditionalTimeCharges
      : 0;
    l_decCharges += MNVQuote.AdditionalStairsCharges
      ? MNVQuote.AdditionalStairsCharges
      : 0;

    var Message =
      "Do you want to save the charges of £" +
      l_decCharges?.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) +
      " - the last van will charge the clients card";
    if (IsThisLastVanToComplete)
      Message =
        "Do you want to save the charges of £" +
        l_decCharges?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) +
        "?";

    setConfirmationModalObject({
      ShowPopup: true,
      Heading: "Confirmation",
      Message: Message,
      ID: 1,
      SelectedID: 0,
      OtherID: 0,
    });

    // Swal.fire({
    //   text: "Do you want to save additional charges?",
    //   icon: "warning",
    //   showCancelButton: true,
    // }).then((r) => {
    //   if (r.isConfirmed) {
    //     AddAdditionalChargesLineItem(MNVQuote.LineItemType);
    //   }
    // });
  };

  const AddAdditionalChargesLineItem = (
    p_intType: number,
    p_boolIsLast = 1,
  ) => {
    const quote = MNVQuoteRef.current;

    if (p_intType === 1) {
      const l_strReference = "Additional Time";
      const l_strTitle =
        "Additional " +
        GetDurationTextForSeconds(quote.Mover2ID * 60) +
        " charge" +
        VanText;

      AjaxSaveLineItem(
        1,
        quote.AdditionalTimeCharges,
        l_strTitle,
        l_strReference,
        props.QuoteID,
        0,
        p_boolIsLast,
      );
    } else if (p_intType === 2 && quote.AdditionalStairsCharges > 0) {
      const l_strReference = "Additional Stairs";
      const l_strTitle =
        "Additional " +
        quote.Mover3ID +
        (quote.Mover3ID > 1 ? " Stairs charge" : " Stair charge") +
        VanText;

      AjaxSaveLineItem(
        1,
        quote.AdditionalStairsCharges,
        l_strTitle,
        l_strReference,
        props.QuoteID,
        0,
        p_boolIsLast,
      );
    } else if (p_intType === 2 && quote.AdditionalStairsCharges < 0) {
      const l_strReference = "Additional Stairs";
      const l_strTitle =
        "Additional " +
        quote.Mover3ID +
        (Math.abs(quote.Mover3ID) > 1 ? " Stairs charge" : " Stair charge") +
        VanText;

      AjaxSaveLineItem(
        3,
        quote.AdditionalStairsCharges,
        l_strTitle,
        l_strReference,
        props.QuoteID,
        0,
        p_boolIsLast,
      );
    } else if (p_intType === 4 && quote.LineItemValue > 0) {
      const l_strReference = "Additional Parking Costs";
      const l_strTitle = "Parking Costs" + VanText;

      AjaxSaveLineItem(
        1,
        quote.LineItemValue,
        l_strTitle,
        l_strReference,
        props.QuoteID,
        0,
        p_boolIsLast,
      );

      // document.getElementById("closeaddcosts")?.click();
    } else if (p_intType === 5 && quote.LineItemValue > 0) {
      const l_strReference = "Additional PCN / Fine";
      const l_strTitle = "PCN / Fine" + VanText;

      AjaxSaveLineItem(
        100,
        quote.LineItemValue,
        l_strTitle,
        l_strReference,
        props.QuoteID,
        0,
        p_boolIsLast,
      );

      // document.getElementById("closeaddcosts")?.click();
    } else if (p_intType === 6 && quote.LineItemValue > 0) {
      const l_strReference = "Additional Mattress Cover(s)";
      const l_strTitle = "Mattress Cover(s)" + VanText;

      let l_decCharges = quote.LineItemValue * quote.MattressCoversFee;

      if (quote.MNVMoveTypeServiceID !== 7) {
        l_decCharges = quote.LineItemValue * quote.MattressCoversSellingFee;
      }

      AjaxSaveLineItem(
        1,
        l_decCharges,
        l_strTitle,
        l_strReference,
        props.QuoteID,
        0,
        p_boolIsLast,
      );

      document.getElementById("closeaddcosts")?.click();
    } else if (p_intType === 7 && quote.LineItemValue > 0) {
      const l_strReference = "Additional Disposal Service";
      const l_strTitle = "Disposal Service" + VanText;

      AjaxSaveLineItem(
        1,
        quote.LineItemValue,
        l_strTitle,
        l_strReference,
        props.QuoteID,
        0,
        p_boolIsLast,
      );

      // document.getElementById("closeaddcosts")?.click();
    }
  };

  const AjaxSaveLineItem = (
    Type: number,
    Amount: number,
    Note: string,
    RefID: string,
    QuoteID: number,
    MarkPaid: number,
    p_boolIsLast: number,
  ) => {
    const quote = MNVQuoteRef.current;

    const data: any = {};
    data.Type = Type;
    data.Amount = Amount;
    data.Note = Note;
    data.RefID = RefID;
    data.MNVJobID = GetMainJobID();
    data.QuoteID = QuoteID;

    if (quote.ParentID > 0) {
      data.QuoteID = quote.ParentID;
    }

    data.MarkPaid = MarkPaid;
    data.IsDriverSide = true;
    data.LineItemType = 1;

    // IMPORTANT: same overwrite as original code
    data.RefID = Note;

    setShowAnimation(true);

    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuoteAdmin/AjaxSaveLineItem", data)
      .then((response) => {
        setShowAnimation(false);

        const StatusData = response.data[0][0];

        if (StatusData.Status === 1 && p_boolIsLast) {
          showSuccessMessage("Line item has been added successfully.");
          AddAdditionalChargesInputs();
          GetInvoiceDataByQuoteID();
          LoadAllQuotesLinkedToThisJob(GetMainJobID());

          quote.QuoteLoadingTime = addMinutes(new Date(), 0.016 * 2);
          MNVQuoteRef.current = quote.QuoteLoadingTime;
          CheckIfAllTheOtherVansAreCompleted(1);
        } else if (p_boolIsLast) {
          showErrorMessage(StatusData.Message);
        }
      })
      .catch((error) => {
        setShowAnimation(false);
        console.error("AjaxSaveLineItem error:", error);
      });
  };

  const LoadAllQuotesLinkedToThisJob = (MNVJobID: number) => {
    const data: any = {};
    data.MNVJobID = MNVJobID;

    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteAdmin/MNVQuoteGetDataSetByMNVJobIDCustom",
        data,
      )
      .then((response) => {
        const result = response.data;

        if (result[1] && result[1][0]) {
          setJobRelatedData((prev: any) => ({
            ...prev,
            Amounts: result[1][0],
          }));
        }

        // CalculatePayments();
      })
      .catch((error) => console.error(error));
  };

  const AddAdditionalChargesInputs = () => {
    const quote = MNVQuoteRef.current;

    const data: any = {};
    data.MNVQuoteID = props.QuoteID;
    data.Mover2ID = quote.Mover2ID ? quote.Mover2ID : 0;
    data.Mover3ID = quote.Mover3ID ? quote.Mover3ID : 0;

    setShowAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/AddAdditionalChargesInputs",
        data,
      )
      .then(() => {
        setShowAnimation(false);
        GetQuoteInfoById(true);
      })
      .catch((error) => {
        setShowAnimation(false);
        console.error(error);
      });
  };

  function GetMainJobID() {
    return MNVQuoteRef.current.MNVJobID;
  }

  const DeleteLineItem = (id: any) => {
    // Swal.fire({
    //   title: "Delete?",
    //   showCancelButton: true,
    // }).then((r) => {
    //   if (r.isConfirmed) {
    //     axios.post(AppContext.APIURL + "api/MNVQuoteAdmin/AjaxDeleteLineItem", {
    //       PTPaymentInvoiceLineItemID: id,
    //     });
    //   }
    // });

    setConfirmationModalObject({
      ShowPopup: true,
      Heading: "Are you sure",
      Message: "You won't be able to revert this!",
      ID: 2,
      SelectedID: id,
      OtherID: 0,
    });
  };

  const AjaxDeleteLineItem = (PTPaymentInvoiceLineItemID: number) => {
    const quote = MNVQuoteRef.current;

    const data: any = {};
    data.QuoteID = GetMainJobID();
    data.MNVServiceID = props.QuoteID;

    if (quote.ParentID > 0) {
      data.MNVServiceID = quote.ParentID;
    }

    data.PTPaymentInvoiceLineItemID = PTPaymentInvoiceLineItemID;
    data.IsDriverSide = true;

    setShowAnimation(true);

    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuoteAdmin/AjaxDeleteLineItem", data)
      .then((response) => {
        setShowAnimation(false);

        const l_arrResponse = response.data[0][0];

        if (l_arrResponse.Status === 1) {
          AddAdditionalChargesInputs();
          GetInvoiceDataByQuoteID();
          LoadAllQuotesLinkedToThisJob(GetMainJobID());

          showSuccessMessage("Line item has been deleted successfully.");
        } else {
          showErrorMessage(l_arrResponse.Message);
        }
      })
      .catch((error) => {
        setShowAnimation(false);
        console.error(error);
      });
  };

  const ChangeJobStatus = (p_intCallPayment = 0) => {
    const data: any = {};
    data.RelMNVQuoteAndMNVMoverID = props.RelMNVQuoteAndMNVMoverID;
    data.Status = 5;
    data.SendReviewEmail = SendReviewEmail;
    data.BusinessCard = BusinessCard;
    data.MagneticCard = MagneticCard;
    data.SocialMediaLeaflet = SocialMediaLeaflet;

    setShowAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/MNVQuoteUpdateDriverJobStatus",
        data,
      )
      .then(() => {
        setShowAnimation(false);

        setAutoSaveMessage(true);
        props.ClosePopupAndAutoSendSms("");
        if (p_intCallPayment > 0) {
          TakeQuoteExtraPaymentConfirmation();
        }
      })
      .catch((error) => {
        setShowAnimation(false);
        console.error(error);
      });
  };

  function TakeQuoteExtraPaymentConfirmation() {
    var Message =
      "Do you want to charge the card for £" +
      LineItemsAmounts.Balance?.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) +
      "?";

    setConfirmationModalObject({
      ShowPopup: true,
      Heading: "Alert",
      Message: Message,
      ID: 3,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  const CheckIfAllTheOtherVansAreCompleted = (p_boolChangeStatus: any) => {
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteAdmin/CheckIfAllTheOtherVansAreCompleted",
        {
          MNVQuoteID: props.QuoteID,
        },
      )
      .then((res) => {
        var l_arrResponse = res.data[0] as any;
        if (l_arrResponse.Status == 1) {
          setIsThisLastVanToComplete(true);
        }

        //if (p_boolChangeStatus && res.data[0].Status != 1) ChangeJobStatus();
      });
  };

  /* ===================== JSX (FULL HTML) ===================== */

  const [confirmationModalObject, setConfirmationModalObject] = useState<any>({
    ShowPopup: false,
    Heading: "",
    Message: "",
    ID: 0,
    SelectedID: 0,
    OtherID: 0,
  });

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        if (
          MNVQuote.AdditionalTimeCharges &&
          MNVQuote.AdditionalTimeCharges > 0 &&
          MNVQuote.AdditionalStairsCharges &&
          MNVQuote.AdditionalStairsCharges > 0
        ) {
          AddAdditionalChargesLineItem(1, 0);
          AddAdditionalChargesLineItem(2, 1);
        } else if (
          MNVQuote.AdditionalTimeCharges &&
          MNVQuote.AdditionalTimeCharges > 0
        )
          AddAdditionalChargesLineItem(1);
        else if (
          MNVQuote.AdditionalStairsCharges &&
          MNVQuote.AdditionalStairsCharges > 0
        )
          AddAdditionalChargesLineItem(2);
      }
    }

    if (obj.ID === 2) {
      if (obj.isConfirm === true) {
        AjaxDeleteLineItem(obj.SelectedID);
      }
    }
    if (obj.ID === 3) {
      if (obj.isConfirm === true) {
        TakeQuoteExtraPayment();
      }
    }

    setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  const TakeQuoteExtraPayment = () => {
    const quote = MNVQuoteRef.current;

    const data: any = {};
    data.MNVJoID = GetMainJobID();
    data.MNVQuoteID = props.QuoteID;
    data.Balance = LineItemsAmounts.Balance;

    setShowAnimation(true);

    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuoteAdmin/TakeQuoteExtraPayment", data)
      .then((response) => {
        setShowAnimation(false);

        const l_arrResponse = response.data[0];

        if (l_arrResponse.Status === 1) {
          if (l_arrResponse.RequiredAction) {
            showInfoMessage(
              "The card was declined. This transaction requires further authentication.",
            );
          } else {
            if (quote.MNVQuoteStatusID === 0 || quote.MNVQuoteStatusID === 6) {
              quote.MNVQuoteStatusID = 1;
            }

            GetInvoiceDataByQuoteID();

            showSuccessMessage("Payment has been taken successfully");
          }
        } else {
          if (l_arrResponse.RequiredAction) {
            showInfoMessage(
              "The card was declined. This transaction requires further authentication.",
            );
          } else {
            showErrorMessage(l_arrResponse.Message);
          }
        }
      })
      .catch((error) => {
        setShowAnimation(true);
        console.error(error);
      });
  };

  function OpenAddCostPopup() {
    setMNVQuote({
      ...MNVQuote,
      LineItemType: 0,
    });
    setShowAddCostModal(true);
  }

  function OpenSendPaymentLinkPopup() {
    setClientData((prev: any) => ({
      ...prev,
      EnteredEmailAddress: ClientData.EmailAddress,
      EnteredMobile: ClientData.Mobile,
    }));

    setMNVQuote({
      ...MNVQuote,
      LineItemType: 0,
    });
    setShowSendPaymentLink(true);
  }

  const SendPaymentLink = (TypeID: number) => {
    const client = ClientData;
    const balance = LineItemsAmounts.Balance;

    // Validate input
    if (
      (TypeID === 1 && client.EmailAddress !== "") ||
      (TypeID === 2 && client.Mobile !== "") ||
      (TypeID === 3 && client.EmailAddress !== "" && client.Mobile !== "")
    ) {
      const data: any = {};
      data.MNVJobID = GetMainJobID();
      data.EmailAddress = client.EmailAddress;
      data.Mobile = client.Mobile;
      data.EnteredEmailAddress = client.EnteredEmailAddress;
      data.EnteredMobile = client.EnteredMobile;
      data.TypeID = TypeID;
      data.Amount = Number(balance / 1.2);
      data.VAT = Number(balance - data.Amount);

      setShowAnimation(true);

      axiosAuth
        .post(AppContext.APIURL + "api/MNVQuoteAdmin/SendPaymentLink", data)
        .then((response) => {
          setShowAnimation(false);

          const l_arrResponse = response.data[0][0];

          if (l_arrResponse.Status === 1) {
            showSuccessMessage("Link has been sent.");
          } else {
            showErrorMessage(l_arrResponse.Message);
          }
        })
        .catch((error) => {
          setShowAnimation(false);
          console.error(error);
        });
    } else {
      showErrorMessage("Please enter the valid mobile number and email.");
    }
  };

  const TakeOrRefundAmount = (p_intType: number) => {
    if (p_intType === -1 || p_intType === 0) {
      RefundQuoteExtraPayment(p_intType);
    } else if (p_intType === 1) {
      TakeQuoteExtraPaymentConfirmation();
    }
  };

  const RefundQuoteExtraPayment = (p_intType: number) => {
    const data: any = {};
    data.MNVQuoteID = props.QuoteID;
    data.Type = p_intType;
    data.Balance = Math.abs(LineItemsAmounts.Balance);
    data.RefundMessage = p_intType === -1 ? "Manual Refund" : "";

    setShowAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/RefundQuoteExtraPayment",
        data,
      )
      .then((response) => {
        setShowAnimation(false);

        const l_arrResponse = response.data[0];

        if (l_arrResponse.Status === 1) {
          GetInvoiceDataByQuoteID();

          showSuccessMessage("Refund has been made successfully");
        } else {
          showErrorMessage(l_arrResponse.Message);
        }
      })
      .catch((error) => {
        setShowAnimation(false);
        console.error(error);
      });
  };

  function CloseThisJob() {
    ChangeJobStatus();
  }

  return (
    <>
      <ConfirmationModal
        ConfirmationObject={confirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />
      {showAnimation && <LoadingAnimation />}
      {/* ================= ADDITIONAL TIME ================= */}
      {markAsComplete == false && (
        <>
          <div className="grid-d fr-111 gap-20">
            <div className="field-input grid-d  flex-gap3">
              <span className="font-12 text-left label-color">
                Additional Time in Hours
              </span>
              <input
                type="number"
                className="input-field w-100"
                value={MNVQuote.AdditionalTimeInHours || ""}
                onChange={(e) =>
                  setMNVQuote({
                    ...MNVQuote,
                    AdditionalTimeInHours: e.target.value,
                  })
                }
                //  onKeyUp={CalculateAdditionalTimeAmount}
              />
            </div>

            <div className="field-input grid-d  flex-gap3">
              <span className="font-12 text-left label-color">
                Additional Time in Minutes
              </span>
              <input
                type="number"
                className="input-field w-100"
                value={MNVQuote.AdditionalTimeInMinutes || ""}
                onChange={(e) =>
                  setMNVQuote({
                    ...MNVQuote,
                    AdditionalTimeInMinutes: e.target.value,
                  })
                }
                // onKeyUp={CalculateAdditionalTimeAmount}
              />
            </div>

            <div className="field-input grid-d  flex-gap3">
              <span className="font-12 text-left label-color">
                Additional Time Charges
              </span>
              <span className="font-12 text-left label-color">
                £
                {(MNVQuote.AdditionalTimeCharges || 0)?.toLocaleString(
                  undefined,
                  {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  },
                )}
              </span>
            </div>

            <div className="field-input grid-d  flex-gap3">
              <span className="font-12 text-left label-color">
                Additional Stairs
              </span>
              <input
                type="number"
                className="input-field w-100"
                value={MNVQuote.Mover3ID || ""}
                onChange={(e) =>
                  setMNVQuote({ ...MNVQuote, Mover3ID: e.target.value })
                }
                // onKeyUp={CalculateAdditionalStairsAmount}
              />
            </div>

            <div className="field-input grid-d  flex-gap3">
              <span className="font-12 text-left label-color">
                Additional Stairs Charges
              </span>
              <span className="font-12 text-left label-color">
                £
                {(MNVQuote.AdditionalStairsCharges || 0)?.toLocaleString(
                  undefined,
                  {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  },
                )}
              </span>
            </div>
          </div>

          {/* ================= SAVE CHARGES ================= */}
          {((MNVQuote.AdditionalTimeCharges != "" &&
            MNVQuote.AdditionalTimeCharges != 0) ||
            (MNVQuote.AdditionalStairsCharges != "" &&
              MNVQuote.AdditionalStairsCharges != "00")) && (
            <div className="flex-daj btn-start mt--15">
              <a className="btn-primary flex-daj" onClick={SaveCharges}>
                + Save Additional Charges
              </a>
            </div>
          )}

          {/* ================= LINE ITEMS ================= */}
          <div className="grid-d flex-daj flex-gap10 mt-20 font-mont">
            {LineItems &&
              LineItems.map((li: any, i: any) => (
                <div className="flex-daj flex-gap10" key={i}>
                  <span>{li.RefferenceNumber}:</span>
                  <span className="bold-font">
                    £
                    {li.Amount?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                  {li.CanDelete && (
                    <a
                      onClick={() =>
                        DeleteLineItem(li.PTPaymentInvoiceLineItemID)
                      }
                    >
                      <img
                        src="images/delete.png"
                        width="18px"
                        height="18px"
                        alt="Delete"
                      />
                    </a>
                  )}
                </div>
              ))}
          </div>

          {/* ================= ADD COST BUTTON ================= */}
          <div className="flex-daj btn-start mt--15">
            <a
              className="btn-primary flex-daj"
              onClick={() => OpenAddCostPopup()}
            >
              + Add Costs
            </a>
          </div>

          {/* ================= TOTALS ================= */}
          <div className="flex-daj flex-gap20 font-mont mt-20">
            <div className="flex-da flex-gap5">
              <span>Amount:</span>{" "}
              <span className="bold-font">
                £
                {QuoteCalculations.AmountBeforeVAT?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </div>
            <div className="flex-da flex-gap5">
              <span>VAT:</span>{" "}
              <span className="bold-font">
                £
                {QuoteCalculations.TotalVAT?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </div>
            <div className="flex-da flex-gap5">
              <span>Balance:</span>{" "}
              <span className="bold-font">
                £
                {LineItemsAmounts.Balance?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </div>
          </div>

          {/* ================= CHECKBOXES ================= */}
          <div className="grid-d flex-daj">
            <div className="flex-da flex-gap10 mt-20 font-mont">
              <input
                type="checkbox"
                checked={SendReviewEmail}
                onChange={(e) => setSendReviewEmail(e.target.checked)}
              />{" "}
              Email for Review
            </div>

            <div className="flex-daj flex-gap10 mt-20 font-mont bold-font">
              Have you given the client a:
            </div>
            <div className="flex-da flex-gap10 mt-20 font-mont">
              <input
                type="checkbox"
                checked={BusinessCard}
                onChange={(e) => setBusinessCard(e.target.checked)}
              />{" "}
              Business Card
            </div>
            <div className="flex-da flex-gap10 mt-20 font-mont">
              <input
                type="checkbox"
                checked={MagneticCard}
                onChange={(e) => setMagneticCard(e.target.checked)}
              />{" "}
              Magnetic Card
            </div>
            <div className="flex-da flex-gap10 mt-20 font-mont">
              <input
                type="checkbox"
                checked={SocialMediaLeaflet}
                onChange={(e) => setSocialMediaLeaflet(e.target.checked)}
              />{" "}
              Social Media Leaflet
            </div>
          </div>

          {/* ================= FOOTER ================= */}
          <div className="flex-da flex-jse btn-start flex-gap10 mt-20">
            {IsThisLastVanToComplete && LineItemsAmounts.Balance > 0 && (
              <>
                <a
                  className="flex-daj btn-primary"
                  onClick={() => OpenSendPaymentLinkPopup()}
                >
                  + Send New Card Payment Link
                </a>
                <a
                  className="flex-daj btn-primary"
                  onClick={() => TakeOrRefundAmount(1)}
                >
                  £ Charge Card
                </a>
              </>
            )}

            {(!IsThisLastVanToComplete || (IsThisLastVanToComplete && LineItemsAmounts.Balance == 0)) &&
            <a
              className="flex-daj btn-primary"
              onClick={() => setMarkAsComplete(true)}
            >
              ✓ Mark as Completed
            </a>
            }
          </div>
        </>
      )}
      {props.QuoteID > 0 && (
        <div>
          <Conversation
            OtherEntityID={props.QuoteID}
            MessageTypeID={4}
            AutoSaveMessage={AutoSaveMessage}
            ShowCloseJob={markAsComplete}
            CloseThisJob={CloseThisJob}
            ShowMoveLeader={1}
          />
        </div>
      )}

      {showAddCostModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner sm-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">Add Cost</h3>
                <a
                  className="close-help"
                  onClick={() => setShowAddCostModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="grid-d gap-20 mt-20">
                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color">
                    Cost Type
                  </span>

                  <select
                    className="input-field w-100"
                    value={MNVQuote.LineItemType}
                    onChange={(e) =>
                      setMNVQuote((prev: any) => ({
                        ...prev,
                        LineItemType: Number(e.target.value),
                      }))
                    }
                  >
                    <option value={0}>Please Select</option>
                    <option value={4}>Parking Costs</option>
                    <option value={7}>Disposal Service</option>
                    <option value={5}>PCN / Fine (NO VAT)</option>
                    <option value={6}>Mattress Cover(s)</option>
                  </select>
                </div>

                <div className="field-input grid-d  flex-gap3">
                  {MNVQuote.LineItemType > 0 && MNVQuote.LineItemType !== 6 && (
                    <span className="font-12 text-left label-color">
                      Amount (£)
                    </span>
                  )}
                  {MNVQuote.LineItemType === 6 && (
                    <span className="font-12 text-left label-color">
                      Number Of Mattress Cover(s):
                    </span>
                  )}
                  {MNVQuote.LineItemType > 0 && (
                    <input
                      type="number"
                      className="input-field w-100"
                      value={MNVQuote.LineItemValue ?? ""}
                      onChange={(e) =>
                        setMNVQuote((prev: any) => ({
                          ...prev,
                          LineItemValue: Number(e.target.value),
                        }))
                      }
                    />
                  )}
                </div>
              </div>
              <div className="flex-daj btn-start flex-gap10 mt-20">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    AddAdditionalChargesLineItem(MNVQuote.LineItemType);
                    setShowAddCostModal(false);
                  }}
                >
                  Save
                </a>
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setShowAddCostModal(false)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSendPaymentLink && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner sm-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">Send Payment Link</h3>
                <a
                  className="close-help"
                  onClick={() => setShowSendPaymentLink(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="grid-d gap-20 mt-20">
                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color">Email</span>

                  <input
                    type="text"
                    className="input-field w-100"
                    value={ClientData.EnteredEmailAddress || ""}
                    onChange={(e) =>
                      setClientData((prev: any) => ({
                        ...prev,
                        EnteredEmailAddress: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color">Mobile</span>

                  <input
                    type="text"
                    className="input-field w-100"
                    value={ClientData.EnteredMobile || ""}
                    onChange={(e) =>
                      setClientData((prev: any) => ({
                        ...prev,
                        EnteredMobile: e.target.value,
                      }))
                    }
                  />
                </div>
              </div>

              <div className="flex-daj btn-start flex-gap10 mt-20">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    SendPaymentLink(1);
                    setShowSendPaymentLink(false);
                  }}
                >
                  Email
                </a>
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    SendPaymentLink(1);
                    setShowSendPaymentLink(false);
                  }}
                >
                  SMS
                </a>
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    SendPaymentLink(3);
                    setShowSendPaymentLink(false);
                  }}
                >
                  SMS And Email
                </a>
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setShowSendPaymentLink(false)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CompleteJob;
